const animatedEls = document.querySelectorAll('[class*="em-animate--"]');

if (animatedEls.length) {
	const options = {
		threshold: 0.2,
	};

	embark.animationObserver = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			const { target, isIntersecting } = entry;
			if (isIntersecting) {
				target.className = target.className.replace('em-animate--', '');
			}
		});
	}, options);

	animatedEls.forEach((element) => {
		embark.animationObserver.observe(element);
	});
}
